import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function EarnAirIndiaIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				d="M13.7188 9.78458L15.3001 16.5346L13.6845 18.3346L10.9001 12.5884L7.63447 15.8077L8.39072 18.8884L7.53135 19.823L5.60635 16.2577L1.92822 14.6654L2.7876 13.7307L5.91572 14.2154L8.76885 10.65L2.82197 8.39997L4.4376 6.59997L11.2095 7.53458L13.4438 4.73074L13.822 4.28074C14.1313 3.9692 14.4063 3.89997 14.6126 3.86535C14.9563 3.83074 15.197 3.93458 15.5751 4.07304C15.9876 4.21151 16.4001 4.31535 16.4001 4.31535C16.4001 4.31535 16.5032 4.69612 16.7095 5.11151C16.8813 5.45766 16.9845 5.73458 16.9845 6.04612C16.9845 6.28843 16.9157 6.53074 16.6407 6.87689L16.2282 7.29227L13.7188 9.78458ZM22.8282 11.1692C22.4501 10.1654 22.4157 9.43843 22.4157 9.43843C22.4157 9.43843 21.6938 9.43843 20.697 9.02304C20.1813 8.81535 19.8032 8.78074 19.4595 8.88458C19.1845 8.98843 18.9438 9.12689 18.772 9.33458L17.7407 10.3384L17.4313 10.65L16.4001 11.6538C16.1938 11.8615 16.0563 12.0692 15.9532 12.3461C15.8501 12.6923 15.8845 13.073 16.0563 13.5923C16.4345 14.5961 16.4688 15.323 16.4688 15.323C16.4688 15.323 17.1907 15.323 18.1876 15.7384C18.7032 15.9461 19.0813 15.9807 19.4251 15.8769C19.7001 15.773 19.9407 15.6346 20.1126 15.4269L21.1438 14.423L21.4532 14.1115L22.4845 13.1077C22.6907 12.9 22.8282 12.6923 22.9313 12.4154C23.0345 12.0692 23.0001 11.6884 22.8282 11.1692ZM19.4251 13.1423L18.2907 13.9384L18.7376 12.623L17.672 11.7923H18.9782L19.4938 10.4769L20.5595 13.973L19.4251 13.1423ZM20.2845 12.6577L20.0438 11.7923H21.3157C21.3157 11.8269 20.2845 12.6577 20.2845 12.6577Z"
				fill="currentColor"
			/>
		</svg>
	);
}

EarnAirIndiaIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default EarnAirIndiaIcon;
